import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ERROR_GETTING_DATA } from 'src/app/app.constants';

/** Minimum shape every consumer's items share: `name` drives the labels (bindLabel), `id` the selection identity. */
export interface NgSelectOverrideItem {
  id?: number | string;
  name: string;
}

@Component({
  selector: 'ng-select-override',
  templateUrl: './ng-select-override.component.html',
  styleUrls: ['./ng-select-override.component.scss'],
})
export class NgSelectOverrideComponent implements OnChanges {
  @Input() items: NgSelectOverrideItem[] = [];
  @Input() placeholder: string;
  @Input() multipleSelect = false;
  @Input() displayNumber = 3;
  @Input() setModel: NgSelectOverrideItem[];
  @Input() isLoading = false;
  @Input() error = false;
  /** Forwarded to ng-select's labelForId: sets the inner input's id so an external `<label for="...">` can name the control. */
  @Input() labelForId: string = null;

  @Output() onChange = new EventEmitter<NgSelectOverrideItem | NgSelectOverrideItem[]>();

  _model: NgSelectOverrideItem | NgSelectOverrideItem[];

  get model(): NgSelectOverrideItem | NgSelectOverrideItem[] {
    return this._model;
  }

  set model(value: NgSelectOverrideItem | NgSelectOverrideItem[]) {
    this._model = value;
    this.onChange.emit(value);
  }

  dataError = ERROR_GETTING_DATA;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.setModel) {
      this._model = changes.setModel.currentValue;
    }
  }

  ngSelectOpenOrClose(select: NgSelectComponent): void {
    select.searchable = select.isOpen;
  }

  generateMoreTooltipText(): string {
    const selected = Array.isArray(this.model) ? this.model : [];
    return selected
      .slice(this.displayNumber)
      .map((item) => item.name)
      .join(', ');
  }
}
